import RoleSelectorContainer from './RoleSelectorContainer';

export default RoleSelectorContainer;



// WEBPACK FOOTER //
// ./src/components/common/Profile/RoleSelector/index.js